<table class="config-table config-table-constant">
	<tbody>
	{{#each values}}
	<tr>
		<th>{{name}}</th>
		{{#if ../readOnly}}
			<td>
				<span>{{SHIFT_DECIMAL 1 val}} °C</span>
			</td>
		{{else}}
			<td>
				<input class="js-edit-value input-sm form-control text-right" type="number" id="{{@key}}" step="1" value="{{SHIFT_DECIMAL 1 val}}">
			</td>
			<td class="decoration">
				<span class="input-group-addon last"> °C </span>
			</td>
		{{/if}}
	</tr>
	{{/each}}
	</tbody>
</table>
